export default "__VITE_ASSET__iKziswp$__"